import BacnetObjects from "./BacnetObjects";

const BacnetObjectsWrite = () => <BacnetObjects mode="write" />

export default BacnetObjectsWrite;